
import { _s } from './stores.js'
import NoSleep from './nosleep.js'
import _get from 'lodash/get'
import _pick from 'lodash/pick'
import _omit from 'lodash/omit'
import _clone from 'lodash/cloneDeep'
import _intersection from 'lodash/intersection'
import _isEqual from 'lodash/isEqual'

export async function init(localConf){ 
  if(localConf) _s('conf', localConf)                           //applies localconf
  qss()                                                         //parse hash, query of location
  locale()                                                      //applies locale from storage
  openHrefInit()                                                //catch all <a> click
  routeCold()                                                   //set route that comes from qss
  if (typeof window === 'undefined') return                     //means we are in SSR
  mediaSize()                                                   //set an event that will track mediaSize and set $w.media
  if(_s('conf').wsUrl && !_s('wsc')) _s('wsc', new wsclient())  //create a wsc client
}

// --------------------------------------------
// ----- base fcts
// --------------------------------------------
export function tz() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
}

export function locale(setLocale){
  let resultLang
  if(!setLocale && _s('conf').qss && _s('conf').qss.lang) resultLang=_s('conf').qss.lang
  else if(setLocale || _s('lang')) {
    resultLang=setLocale || _s('lang')
  } else {
    let langs=_s('conf').langs || [] 
    //console.log(langs)
    let navLangs=[]
    if (typeof navigator !== 'undefined') navLangs=navLangs.concat(navigator.languages || [navigator.language])    
    let intersectionLangs=[]
    navLangs.forEach(testLang => {
      if(langs.includes(testLang)) {
        intersectionLangs.push(testLang)
      } else {
        const LeftLang=testLang.split('-')[0]
        if(langs.includes(LeftLang)) intersectionLangs.push(LeftLang)
      }
    })
    intersectionLangs.push(langs[0] || navLangs[0])
    resultLang=intersectionLangs[0]
  }
  if(resultLang) _s('lang',resultLang)
  return resultLang
}

export function u(value) {//return '' if undefined or false
  if(value == undefined || !value) return ''; else return value;
}

export function closest(evt, id) { //return closest id
  let elt=evt.target.closest('['+id+']')
  if(elt) return elt.getAttribute(id)
  else return ''
}


function qss(){ //analyze query string + path + hash @ start and return obj of key,value
  _s('conf',{qss:{}})
  if (typeof window === 'undefined') return //means we are in SSR
  let params={}
  for (const [param, value] of new URLSearchParams(window.location.search)) {
    try {value = JSON.parse(value)}
    catch {}
    params[param] = value
    if(param=='debug' && value) _s('conf', { debug:true })
  }
  let pathArray = window.location.pathname.split('/')
  let hash = location.hash.substr(1)
  let ret={qss: { ...params, ...{ path: window.location.pathname, pathBase: pathArray[1], hash: hash} } }
  _s('conf',ret)
  return ret
}

// --------------------------------------------
// ----- route fcts
// --------------------------------------------

export function routeCold(){
  if(_s('conf').qss && _s('conf').qss.route) setRoute(_s('conf').qss.route)
  else if(_s('conf').qss && _s('conf').qss.hash) setRoute(_s('conf').qss.hash)
}

export async function setRouteRoot(route, routeName=""){
  if(!route) route="/"
  console.log('@setRouteRoot'+routeName, route)
  _s('routeRoot'+routeName, route)
}

export async function reloadRoute(routeName=""){
  _s('routeReload'+routeName, _s('routeReload'+routeName)+1)
}

export async function setRoute(route, setAsRoot, params, noReload, routeName=""){
  let routeWas=_s('route'+routeName)
  if(setAsRoot) setRouteRoot(route, routeName)
  if(!route || route=='/') route=_s('routeRoot'+routeName)
  _s('routeMatched'+routeName, false)
  _s('route'+routeName, route)
  if(routeWas==route && !noReload) _s('routeReload'+routeName, _s('routeReload'+routeName)+1) //to force reactive route
  //_s('routeReload', _s('routeReload')+1) //to force reactive route
  if(params) _s('routeParams'+routeName, params)
  console.log('@setRoute'+routeName, route, _s('routeReload'))
}

export function isRoute(route,paths,routeName=""){
  if(!paths) return matchRoute(_s('route'+routeName), route).match
  else return matchRoute(route, paths).match
}

export function isRouteRoot(routeName=""){
  if(_s('routeRoot'+routeName)==_s('route'+routeName)) return true
}

export function matchRoute(route, paths) {
  let matched=false
  asArray(paths).forEach(path => {
    if(!route || !path || matched) return //don't try if nothing or route already matched
    // path /user/show*r/:id/:filter
    // route /user/shower/12345/go
    let pathSegments=path.replace(/\/$/, '').split('/')
		let routeSegments=route.replace(/\/$/, '').split('/')
    let isMatch=true
    let params={}
    pathSegments.forEach((pathSeg, i)=>{
      let isSegMatch=false
      if(pathSeg.charAt(0)==":"){ //seek for dynamic attributes
        if(pathSeg.endsWith("?")) isSegMatch=true //not mandatory attributes
        else if(routeSegments[i]) isSegMatch=true //mandatory attributes
        params[pathSeg.substring(1).replace('?','')]=routeSegments[i] || '' //remove extra : and ? of dynamic id attribute
      } 
      let preregex=pathSeg.replace("*",".*").replace("+",".+")
      const regex = new RegExp("^"+preregex+ "$")
      if(regex.test(routeSegments[i] || '')) isSegMatch=true //test * joker in segment
      //console.log(preregex, pathSeg, routeSegments[i],isSegMatch)
      isMatch= isMatch && isSegMatch
    })
    //finally if route is longer than path, path segment should be a * to validate 
    if(pathSegments.length<routeSegments.length && pathSegments.pop()!="*") isMatch=false
    if(isMatch) matched={routeParams:params, match:isMatch, path:path}
  })
  return matched
}



// --------------------------------------------
// ----- json, css
// --------------------------------------------

export function check(obj, path, _default=false){
  if(!obj) return _default
  if(!path) return obj
  return _get(obj, path, _default)
}

export async function loadJS(url, type=null){
  return new Promise(function(resolve, reject) {
    let script = document.createElement('script')
    if(type) script.type=type
    script.src=url
    document.head.appendChild(script)
    script.onload = function(){
      resolve()
    }
    script.onerror = function(){
      reject()
    }
  })
}

export async function loadCSS(url) {
  return new Promise(function(resolve, reject) {
    let link = document.createElement('link')
    link.rel  = 'stylesheet'
    link.href = url
    document.head.appendChild(link)
    link.onload = function() {
      resolve()
    }
  })
}

export function jsonSafeParse(value){
  try{return JSON.parse(value)}
  catch(err) {return value}
}

export function setCssVars(cssVars){
  if (typeof window === 'undefined') return //means we are in SSR
  for(let cssVarName in cssVars){
    document.querySelector(":root").style.setProperty('--' + cssVarName, cssVars[cssVarName])
  }
}

export function applyStyles(styles){
  //console.log("@applyStyles",styles)
  if(!document.getElementById("appstylesheet")) {
    let style=document.createElement('style')
    style.id='appstylesheet'
    style.type="text/css"
    document.head.appendChild(style)
  }
  let mySheet=document.getElementById("appstylesheet").sheet
  let rules = mySheet.cssRules ? mySheet.cssRules : mySheet.rules
  let rulesLen=rules.length
  for (let [selector, style] of Object.entries(styles)) {
    selector="."+selector
    if(selector.includes(':focus')) selector=selector.replace(':focus','')+":focus:not(.active)"
    if(selector.includes(':hover')) selector=selector.replace(':hover','')+":hover:not(.active)"
    if(selector.includes(':active')) selector=selector.replace(':active','')+".active"
    if(selector.includes('Hover')) selector=selector.replace('Hover','')+":hover:not(.active)"
    if(selector.includes('Active')) selector=selector.replace('Active','')+".active"
    let cssStr=Object.entries(style).map(([k, v]) => `${k}:${v}`).join(';')
    let ruleIndex=-1
    for (let i=0; i<rulesLen; i++) {
      if (rules[i] && rules[i].selectorText == selector) {ruleIndex=i;break;}
    }
    if(ruleIndex>-1) mySheet.deleteRule(ruleIndex)
    if(style) mySheet.insertRule(`${selector}{${cssStr}}`)
  }
}

export function applyStylesPerms(permissions){
  if(!permissions) permissions=_s("permissions")
  let styles={
    p:{display:"none"}
  }
  if(permissions) for (let [key, value] of Object.entries(permissions)) {
    if(typeof value == 'object') {
      for (let [subKey, subValue] of Object.entries(value)) {
        if(subValue) styles[`p_${key}_${subKey}`]={display:"inherit!important"}
        else styles[`p_${key}_${subKey}`]=false
      }
    } else if(value) styles[`p_${key}`]={display:"inherit!important"}
    else styles[`p_${key}`]=false
  }
  applyStyles(styles)
}
  
export function outOfViewPort(elt) {
  const bounding = elt.getBoundingClientRect()
  const out = {}
  out.top = bounding.top < 0;
  out.left = bounding.left < 0;
  out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight)
  out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth)
  out.any = out.top || out.left || out.bottom || out.right
  return out
}


export function spyScroll(rootMargin='-20% 0px -40% 0px') {
  let sectionsArray = Array.from(document.querySelectorAll('section'))
  let navsArray = Array.from(document.querySelectorAll('.nav-link'))
  let visibles=[]
  let currentSpy=0

  const observerOptions = {
    root: null,
    rootMargin: rootMargin,
    threshold:0
  }
  const observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry) => {
      visibles[sectionsArray.indexOf(entry.target)]=entry.isIntersecting
    })
    const last=visibles.length-1
    if(visibles[0] && visibles[1]) currentSpy=0 //if we see the first and second, so this is first
    else if(visibles[last-1] && visibles[last]) currentSpy=last //if we see the last and beforelast, so this is last
    else currentSpy=visibles.findIndex((el)=> {return el}) //all other case is the first visible
    
    navsArray.forEach((nav, i)=>{ //Set inactive on all
      nav.classList.remove('active')
    })
    if(navsArray[currentSpy]) navsArray[currentSpy].classList.add('active') //add activ on current

  }, observerOptions)

  sectionsArray.forEach((section) => {
    observer.observe(section)
  })
}

// --------------------------------------------
// ----- sw
// --------------------------------------------
export function sw()	{
  if (typeof window === 'undefined') return
  if (navigator.serviceWorker) {
    if (navigator.serviceWorker.controller) { //&& $tweeklStore.pushToken) {
      //register() //Done in swNotify
    } else {
      let p=btoa(JSON.stringify({
        id: _s('conf').id,
        swName: _s('conf').swName,
        cacheExternal: _s('conf').swCacheExternal,
        collectUrl: _s('conf').collectUrl, 
        neverCacheUrls: _s('conf').neverCacheUrls
      }))
      navigator.serviceWorker.register(`/sw?p=${p}`, {
        scope: _s('conf').scope, // './',
        updateViaCache: 'none'
      })
    }
  }
}

export function swInstallPwaSupport()	{
  if (typeof window === 'undefined') return
  if ('BeforeInstallPromptEvent' in window) return true
  //if (platform("iOS") && browser("safari") ) return true
  if (platform("iOS")) return true //If we are on iOS pwa is supported if we use safari. So consider that it is supported, but force people to go on safari
  return false
}

let installPwaPrompt=null
export async function swInstallPwaPrompt(){
  if (typeof window === 'undefined') return
  window.addEventListener('beforeinstallprompt', (e) => {
    _s('pwaInstalled', "no")
    e.preventDefault()
    installPwaPrompt = e
    _s('pwaPrompt', true)
    //console.log('beforeinstallprompt', window.installPwaPrompt)
  })
  window.addEventListener('appinstalled', () => {
    _s('pwaInstalled', "yes")
    console.log('PWA APP was installed')
    if(_s('conf').collectUrl) {
      const payloadData = { v: 1, cid: _s('conf').id, ea: 'pwa-install', ev: platform() }
      fetch(_s('conf').collectUrl, {
        method: 'POST',
        headers: [
          ["Content-Type", "application/json"]
        ],
        body: JSON.stringify(payloadData)
      })
    }
  })
}

export async function swInstallPwa(){
  if (typeof window === 'undefined') return
  installPwaPrompt.prompt()
  const { choice } = await installPwaPrompt.userChoice
  //console.log('afterinstallprompt', choice)
  installPwaPrompt = null
  if(choice=="accepted") return true
}

export function swInPwa(){
  if (typeof window === 'undefined') return
  return window.matchMedia('(display-mode: standalone)').matches
}

// --------------------------------------------
// ----- array, object
// --------------------------------------------

export function isObject(obj){
  return obj && typeof obj === 'object' && obj.constructor === Object;
}

export function isArray(arr){
  return Array.isArray(arr)
}

export function asArray(arr){
  if(arr == null || typeof arr === "undefined") arr=[]
  if( isObject(arr) ) {
    let newArr=[]
    for(let property in arr) {
      let obj=arr[property]
      obj.id=property
      newArr.push(obj)
    }
    arr=newArr
  }
  if( !Array.isArray(arr) ) arr = [ arr ]
  return arr.filter(n => n)
}

export function inArray(val,arr){
  if(!arr) return false
  if(Array.isArray(val)) {
    let ret=_intersection(val,arr)
    return ret.length?ret:false
  } else return arr.indexOf(val)==-1?false:true
}

export function pushUniq(val,arr){
  if(!arr) arr=[]
  if(!inArray(val,arr)) arr.push(val)
  return arr
}

export function toggleInArray(val,arr){
  if(!arr) arr=[]
  if(!inArray(val,arr)) arr.push(val)
  else arr=arr.filter(item => item !== val)
  return arr
}

export function removeFromArray(val,arr){
  if(!arr) arr=[]
  return arr.filter(item => item !== val)
}

export function arrayToObj(arr){
  let ret={}
  if(arr) arr.forEach(
    function(entry) {
      if(entry.id) ret[entry.id]=entry
    }
  )
  return ret
}

export function getById(arrOfObjs,id,colIdName='id', retEmptyObj=false){
  if(typeof arrOfObjs == 'object') arrOfObjs=Object.values(arrOfObjs)
  if(!id || !arrOfObjs || !arrOfObjs.length || typeof arrOfObjs === 'string' ) return retEmptyObj?{}:false
  let ret = arrOfObjs.find(obj => obj[colIdName]==id || obj.shortId==id === id)
  return ret?_clone(ret):retEmptyObj?{}:false
}

export function objToArray(obj){
  if(!obj) return []
  return Object.values(obj)
}

export function objToArrayOfObj(obj){
  if(!obj) return []
  let ret=[]
  for (const property in obj) ret.push({id:property, label:obj[property]})
  return ret
}
   
export function mapObjsIdToArray(objs){ //return list of id, if id exists in object
  if(!objs) return []
  return objs.filter(function (item) {  return item.id  }).map(function(item) { return item.id; })
  //return objs.map(item => item.id) || []
}

export function filterObjs(arrayOfobjs,mapColumnsName){
  let ret=[]
  arrayOfobjs.forEach(val => {
    let obj={}
    for (const property in mapColumnsName) {
      obj.id=property
      obj[mapColumnsName[property]]=val[property]
    }
    if(obj) ret.push(obj)
  })
  return ret
}

export async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

export function pick(obj, properties){
  return _pick(obj, properties)
}

export function omit(obj, properties){
  return _omit(obj, properties)
}


// --------------------------------------------
// ----- generators
// --------------------------------------------
export function uuid(noDash) {
  let f='xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
  if(noDash) f='xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'
  return f.replace(/[xy]/g, function(c) {
    let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function btoaUnicode(str){//window btoa doesn't handle unicode, so we need to handle that
  if (typeof window === 'undefined') return //can't be call in ssr mode
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
   function toSolidBytes(match, p1) {
    return String.fromCharCode('0x' + p1);
  }))
}

export function atobUnicode(str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(atob(str).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}


function urlBase64ToUint8Array(base64String) {
  let padding = '='.repeat((4 - base64String.length % 4) % 4);
  let base64 = (base64String + padding)
  .replace(/\-/g, '+')
  .replace(/_/g, '/');
  let rawData = window.atob(base64);
  let outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function genCode(length = 7){ //return a length key randomized readable chars only
  let key=''
  let characters = '23456789abcdefghjkmnpqrtuvwxyz';
  for (var i = 0; i < length; i++) {
    key += characters.charAt(Math.floor(Math.random() * characters.length))
  }
  return key.toUpperCase()
}

export function code(length = 5){ //return a length key randomized readable chars only
  let key=''
  let characters = '23456789abcdefghjkmnpqrtuvwxyz';
  for (var i = 0; i < length; i++) {
    key += characters.charAt(Math.floor(Math.random() * characters.length))
  }
  return key.toUpperCase()
}

// --------------------------------------------
// ----- API
// --------------------------------------------
export async function api(path, payload={}, opts={}){
  if(opts.spinner) _s('spinner', true)

  let url=(opts.url || _s('conf').apiUrl) + path

  let customerId=null
  if(_s('customerId')) customerId=_s('customerId')

  let method=opts.method?opts.method:'POST'
  payload={ 
    ...{
      debug: false,
      confId: _s('conf').id,
      confType: _s('conf').type || 'app',
      lang: _s('lang'),
      customerId:customerId,
      tz: tz()
    }, ...payload
  }
  let responseContentType
  let Bearer=(opts.token || opts.apiKey || _s('token'))
  if(method!='POST' && payload) url+='?payload='+btoaUnicode(JSON.stringify(payload))
  return fetch(url, {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': Bearer?`Bearer ${Bearer}`:''
    },
    body: method=='POST'?JSON.stringify(payload):null
  })
  .then(async response => {
    if(response.status==401 && !opts.noClearAuthStorage) {
      console.warn('401:clear auth')
      logout()
    }
    
    let contentType = response.headers.get("content-type")
    if(contentType && contentType.includes("application/json")) responseContentType="json"

    if(responseContentType=="json") return response.json()
    else return response
  })
  .then(content => {
    if(opts.spinner) _s('spinner', false)
    if(responseContentType=="json")  return content.payload //return content?content.payload:{}
    else return content
  })
  .catch(error => {
    console.warn('API Error on fetch, wait a minute and retry', error) //, error)
    if(opts.alert) alert('Error, sorry !') 
    if(opts.spinner) _s('spinner', false)
    return
  })
}

export async function logout(){
  if(_s('wsc')) _s('wsc').unsubscribe('user_' + _s('userId'))
  api(`/app/users/logout`)
  _s('token',false)
  _s('user',false)
  _s('customers',false)
  _s('userId',false)
}

function collect(action, value){
  const payloadData = {v: 1, cid: cf.id, ea: action, ev: value}
  if(_s('conf').collectUrl) return fetch(_s('conf').collectUrl, {
    method: 'POST',
    headers: [
      ["Content-Type", "application/json"]
    ],
    body: JSON.stringify(payloadData)
  })
}

let isSames={}
export function isSame(which,checkArgs){//to avoid multiple reload when reactive are same
  if(checkArgs=="clean") {isSames[which]={}; return }
  if(_isEqual(checkArgs, isSames[which])) return true
  isSames[which]=_clone(checkArgs)
  return false
}


// --------------------------------------------
// ----- i18n, date, nl2br, br2nl
// --------------------------------------------

export function i18n(id, replaceArr) {
  if(typeof replaceArr != "array" ) replaceArr=[]// (if we put $lang as second param to have reactivity )
  let ret
  //No id
  if(!id || !Object.keys(id).length) return ''
  
  //i18n array
  let i18n=_s('conf').i18n || {}

  //determine country and code
  let lang=_s('lang')
  let [langCode, langCountry] = lang.split('-')

  //If lang is an id object return
  if(isObject(id)){
    if(id[lang]) ret=id[lang]
    else if(id[langCode]) ret=id[langCode]
    else ret=Object.values(id)[0]
    return specialSprintf(ret, replaceArr)
  }

  //Otherwise look at i18n object
  let firstuppercase, norecord

  //"g|Coucou {0}, comment va {1} ?§Paul§Georges"
  let vals = id.split('§')
  id = vals.shift()

  if(!id.includes('--')) {
    //norecord=true  //give only -- missing record
    id='g--' + id
  }

  let localId=id.split('--').pop()
  let sid=id.toLowerCase()
  if(localId.charAt(0) === localId.charAt(0).toUpperCase()) firstuppercase=true

  if(i18n[sid]){
    if(i18n[sid][lang]) ret=i18n[sid][lang]
    else if(i18n[sid][langCode]) ret=i18n[sid][langCode]
    else if(isObject(i18n[sid])) ret = Object.values(i18n[sid])[0]
  }

  //we don't find the id with lang or langCode
  if(_s('conf').debug && !ret && !norecord && typeof window !== 'undefined'){
    if(!window.i18n) window.i18n={}
    if(!window.i18n[sid]) {
      window.i18n[sid]=localId
      console.info('@i18n missing translation',lang, sid, window.i18n)
    }
  }
  if(!ret) ret = localId || id
  replaceArr=[...vals, ...replaceArr]
  ret=specialSprintf(ret,replaceArr)

  //finally ret and make First char uppercase
  if (firstuppercase && ret) ret = fuc(ret)
  return ret
}

export function i18nBr(id, p1, p2){
  return nl2br(i18n(id, p1, p2))
}

export function fuc(str){
  if(str) return typeof str === 'string'?str.charAt(0).toUpperCase() + str.slice(1):str;
  else return ""
}

export function specialSprintf(str,replaceArr) {
  if(!replaceArr.length) return str
  //specialSprintf("Coucou {0}, comment va {1} ? {2}", ["Paul", "Georges"]));
  //Ret : "Coucou Paul, comment va Georges ? {2}"
  return str.replace(/{([0-9]+)}/g, function(match, number) {
    return typeof replaceArr[number] != 'undefined' ? replaceArr[number] : '';
  })
}

export async function translate(sourceLang,sourceText,targetLang, useFree){
  if(!sourceLang || !sourceText || !targetLang) return
  if(sourceLang==targetLang) return sourceText
  let trans=await api('/app/customers/translate',{
    sourceLang:sourceLang,
    sourceText:sourceText,
    targetLang:targetLang,
    useFree: useFree
  },{spinner:false})
  return trans
}

export function dateCalculate(d, count, what, part, startEndSame) {
  d= new Date(d)
  switch (what) {
    case "firstDayOfYear":
      d.setFullYear(d.getFullYear() + count)
      d.setMonth(0)
      d.setDate(1)
      break
    case "firstDayOfMonth":
      d.setMonth(d.getMonth() + count)
      d.setDate(1)
      break
    case "firstDayOfWeek":
      d.setDate(d.getDate() + count * 7 - d.getDay() + (d.getDay() === 0 ? -6 : 1))
      break
    case "lastDayOfYear":
      d.setFullYear(d.getFullYear() + count)
      d.setMonth(11)
      d.setDate(31)
      break
    case "lastDayOfMonth":
      d.setMonth(d.getMonth() + count +1)
      d.setDate(0)
      break
    case "lastDayOfWeek":
      d.setDate(d.getDate() + count * 7 - d.getDay() + (d.getDay() === 0 ? -6 : 1) + 6)
        break
    case "year":
      d.setFullYear(d.getFullYear() + count)
      break
    case "month":
      d.setMonth(d.getMonth() + count)
      break
    case "week":
      d.setDate(d.getDate() + count * 7)
      break
    case "day":
      d.setDate(d.getDate() + count)
      break
    case "hour":
      d.setHours(d.getHours() + count)
      break
    case "minute":
      d.setMinutes(d.getMinutes() + count)
      break
    case "second":
      d.setSeconds(d.getSeconds() + count)
      break
    case "millisecond":
      d.setMilliseconds(d.getMilliseconds() + count)
      break
  }
  switch(startEndSame){
    case "start": d.setHours(0, 0, 0, 0);break;
    case "end": d.setHours(23, 59, 59, 999);break;
    case "same":break;
  }
  switch(part){
    case "datePart": d=d.toJSON().slice(0, 10);break;
    case "timePart": d=d.toJSON().slice(11,19);break;
    case "hmPart": d=d.toJSON().slice(11,16);break;
    default:break;
  }
  return d
}

export function thisYear() {
  return new Date().getFullYear()
}

export function dateTimeFormat(epochOrISO, format, timezone='UTC', lang){
  if(!epochOrISO) return ''
  let opt={}
  if(typeof epochOrISO === 'number') epochOrISO=epochOrISO*1000
  else epochOrISO = new Date(epochOrISO) //ie : "2019-01-01T00:00:00.000000Z"
    
  switch(format){
    case 'epoch':
      return  Math.floor(new Date(epochOrISO).getTime() / 1000)
      break;
    case 'long':
      opt={weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}
      break;
    case 'medium':
      opt={weekday: 'long', month: 'long', day: 'numeric'}
      break;
    case 'short':
      opt={weekday: 'long', month: 'short', day: 'numeric'}
      break;
    case 'dmy':
      opt={year: 'numeric', month: 'long', day: 'numeric'}
      break;
    case 'dt':
      opt={year: 'numeric', month: 'short', day: 'numeric', hour:'numeric', minute:'numeric'}
      break;
    case 'shortDt':
      opt={month: 'short', day: 'numeric', hour:'numeric', minute:'numeric'}
      break;
    case 'shortTime'://dimanche 7 août, 18:54
      opt={weekday: 'long', month: 'short', day: 'numeric',hour:'numeric', minute:'numeric'}
      break;
    case 'shortTimeSecond'://dimanche 7 août, 18:54:00
      opt={weekday: 'long', month: 'short', day: 'numeric',hour:'numeric', minute:'numeric', second:'numeric'}
      break;
    case 'time':
      opt={hour:'numeric', minute:'numeric'}
      break;
    case 'complete':
    default:
      opt={weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour:'numeric', minute:'numeric'}
  }
  opt.timeZone= tz() || timezone
  try{
    return new Intl.DateTimeFormat(_s("lang") || lang || {}, opt).format(epochOrISO)
  } catch(e){return null}
}

export function daysLeft(date, toZero=true){
  let difference = new Date(date).getTime() - new Date().getTime()
  let left=Math.ceil(difference / (1000 * 3600 * 24))
  return (toZero && left<0)?0:left
}

export function getDaysArray(start, end) {
  start=new Date(start)
  end=new Date(end)
  for(var arr=[],dt=new Date(start); dt<=end; dt.setDate(dt.getDate()+1)){
    arr.push(new Date(dt))
  }
  return arr
}

export function getSlotsArray(day, starthhmm, endhhmm, slot, gap) {
  function addHM(date, hhmm) {
    date=new Date(date)
    let hours=0, minutes=0
    if(typeof hhmm==="string") [hours, minutes] = hhmm.split(':')
    else minutes=hhmm
    return new Date(date.setHours(date.getHours()+parseInt(hours), date.getMinutes()+parseInt(minutes)))
  }
  let start=addHM(day, starthhmm)
  let end=addHM(day, endhhmm)
  for(var arr=[],dt=new Date(start); dt<end; dt.setMinutes(dt.getMinutes()+slot+gap)){
    arr.push({sid:new Date(dt)})
  }
  return arr
}

export function cdn(uri, onEmpty=""){
  if(onEmpty=="blank") onEmpty="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkMAYAADkANVKH3ScAAAAASUVORK5CYII="
  if(onEmpty=="rand") onEmpty="https://picsum.photos/300/200?random="+Math.random()

  if(isObject(uri)) return uri.content //uri.content should be ie : data:image/xxxxxxxxxx
  if(!uri) return onEmpty
  uri=String(uri)
  if(uri.startsWith('http')) return uri
  if(_s('conf').cdnUrl) return _s('conf').cdnUrl +'/'+ uri
  else return onEmpty
}

export function icon(obj){
  if(obj.icon) return cdn(obj.icon)
  else if(obj.logo) return cdn(obj.logo)
}

export function cdnMimeType(uri, noMimeType){
  let extension = uri.split('.').pop()
  let type, mimeType
  switch(extension){
    case "jpg":
      mimeType="image/jpeg"
      type="image"
    break
    case "jpeg":
    case "gif":
    case "png":
    case "webp":
    case "svg":
      mimeType=`image/${extension}`
      type="image"
      break
    case "mov":
    case "mp4":
    case "avi":
      mimeType=`video/${extension}`
      type="video"
      break
    case "mp3":
      mimeType=`audio/${extension}`
      type="audio"
      break
    case "csv":
    case "text":
    case "txt":
      mimeType=`plain/${extension}`
      type="plain"
      break
    default:
      mimeType=`application/${extension}`
      type="application"
  }
  return noMimeType?type:mimeType
}

export async function compressImage(dataUrl, newWidth, imageType, compression) {
  //dataUrl can ba a data: , a blob or url
  //compression only usefull for jpeg or webp (compression between 0 and 1)
  //if newWidth null, keep actual image size
  let image, newHeight, canvas, ctx, newDataUrl

  function onload2promise(obj){
    return new Promise((resolve, reject) => {
        obj.onload = () => resolve(obj)
        obj.onerror = reject
    })
  }
  // Provide default values
  imageType = `image/${imageType || "jpeg"}`
  compression = compression || 0.7

  // Create a temporary image so that we can compute the height of the downscaled image.
  image = new Image()
  let imgpromise = onload2promise(image)
  image.src = dataUrl
  await imgpromise

  newHeight = Math.floor(image.height / image.width * newWidth)

  // Create a temporary canvas to draw the downscaled image on.
  canvas = document.createElement("canvas")
  canvas.width = newWidth || image.width
  canvas.height = newHeight || image.height

  // Draw the downscaled image on the canvas and return the new data URL.
  ctx = canvas.getContext("2d")
  ctx.drawImage(image, 0, 0, canvas.width, canvas.height)

  newDataUrl = canvas.toDataURL(imageType, compression)
  //console.log("@compressImage",canvas.width,canvas.height,imageType, compression)
  return newDataUrl
}

/**
 * @param {string} str Input text
 * @param {boolean} replaceMode Use replace instead of insert
 * @param {boolean} isXhtml Use XHTML 
 * @return {string} Filtered text
*/
export function nl2br(str, replaceMode, isXhtml) {
  let breakTag = (isXhtml) ? '<br />' : '<br>';
  let replaceStr = (replaceMode) ? '$1'+ breakTag : '$1'+ breakTag +'$2';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
}

/**
 * @param {string} str Input text
 * @param {boolean} replaceMode Use replace instead of insert
 * @return {string} Filtered text
*/
export function br2nl(str, replaceMode) {   
  let replaceStr = (replaceMode) ? "\n" : '';
  // Includes <br>, <BR>, <br />, </br>
  return str.replace(/<\s*\/?br\s*[\/]?>/gi, replaceStr);
}

// --------------------------------------------
// ----- Events
// --------------------------------------------
export function on(evtName, callback) {
  if (typeof window === 'undefined') return //can't be call in ssr mode
  window.addEventListener(evtName,callback)
}

export function off(evtName, callback) {
  if (typeof window === 'undefined') return //can't be call in ssr mode
  window.removeEventListener(evtName,callback)
}

export function trigger(evtName, obj) {
  if (typeof window === 'undefined') return //can't be call in ssr mode
  window.dispatchEvent(new CustomEvent(evtName, {detail: obj}))
}

export function isCordovaReady(){
  //console.log('cordova', window.cordova)
  if (typeof window === 'undefined') return
  if(window.cordova) {
    document.addEventListener('deviceready', async function(event) {
      //StatusBar.overlaysWebView(false) //do it here because phonegap cli8.0.0 doesn't follow this plugin directive in config.xml
      //StatusBar.styleLightContent()
      //StatusBar.show()
      //screen.orientation.lock('portrait')
      document.addEventListener ( "backbutton ", onBackKeyDown , true) //android cordova specific
      //await loadJS('js/cordovaConfig.js')
      //console.log('isCordovaReady', "OK")
      trigger('ready')
    }, false)
  } else trigger('ready')
}

function onBackKeyDown (e) {
  //e.preventDefault ()
  //console.log('@ onBackKeyDown','Back Button is pressed')
}

export function anchor(id){
  let element = document.getElementById("hr"+id.target?.textContent)
  if(element) element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
}

function noSleep(state){
  if (typeof window === 'undefined') return
  if(window.nosleep) {
    //console.log('@noSleep','state',state)
    if(state) nosleep.enable()
    else nosleep.disable()
  }
  if(!window.nosleep && state) {
    document.addEventListener('click', function enableNoSleep() {
      window.nosleep = new NoSleep()
      noSleep(true)
    }, {once:true})
  }
}

export function sleep(ms, withSpinner) {
  if (!ms) ms = 10
  if(withSpinner) _s('spinner', true)
  return new Promise(resolve => setTimeout(()=>{
    if(withSpinner) _s('spinner', false)
    resolve()
  }, ms))
}

export function toast(msg, color, timeout){
  const id=uuid()
  let toasts=_s('state').toasts
  if(!toasts) toasts=[]
  toasts.push({id: id, msg: msg, color: color, timeout:timeout})
  _s('state',{toasts: toasts})
  setTimeout(()=>{
    toasts=_s('state').toasts
    toasts= toasts.filter(t => t.id != id)
    _s('state',{toasts: toasts})
  }, timeout*1000 || 4000)
}

export function fileExt(url) {
  if(!url) return
  var ext = url.substr(url.lastIndexOf('/') + 1),
    ext = ext.split('?')[0],
    ext = ext.split('#')[0],
    dot = ext.lastIndexOf('.');
  return dot > -1 ? ext.substring(dot + 1) : '';
}

function mediaSize() {
  if (typeof window === 'undefined') return //means we are in SSR
  let media=getComputedStyle(document.documentElement).getPropertyValue('--infoMedia')
  let size=getComputedStyle(document.documentElement).getPropertyValue('--infoSize')
  _s('w', {media:media, size:size})
  window.onresize = ()=>{
    let media=getComputedStyle(document.documentElement).getPropertyValue('--infoMedia')
    let size=getComputedStyle(document.documentElement).getPropertyValue('--infoSize')
    _s('w', {media:media, size:size})
  }
}


function openHrefInit(){
  if (typeof window === 'undefined') return //means we are in SSR
  /* catch all clicks on A tag and decide how to opens it */
  document.addEventListener('click', function (event) {
    let a=event.target.closest("a")
    if(a && a.getAttribute("href")) {
      let opts={}
      if(a.getAttribute("normal")) opts.normal=true
      if(a.getAttribute("location")) opts.location=true
      if(a.getAttribute("route")) opts.route=true
      let ret = openHref(a.getAttribute("href"), opts)
      if(!ret) {event.preventDefault()}
    }
  }, false)
}

export function openHref(href, opts={}) {
  //console.log('@openHref', href, opts)
  if(!href) return

  //from G_Route
  if(href.startsWith("./#/")) { //local $route ie : ./#/register/visitor
    setRoute('/'+href.slice(4))
    return
  }
  if(opts.route) { //local $route ie : /register/visitor
    setRoute(href)
    return
  }
  //End from G_Route



  //just open href in the current window (as window.location)
  if(opts.location){
    window.location=href;return false;
  }

  //force opening special href to system in cordova IOS - FU***ios !!!
  if(window.cordova && helper.platform('iOS')){
    if(href.startsWith("tel:") || href.startsWith("mailto:") || href.startsWith("sms:")){
      //console.log('@openHref', "IOS - catch tel, mailto, sms and opens in the system browser")
      cordova.InAppBrowser.open(href, '_system')
      return false
    }
  }
  
  if(!href.startsWith("http")) return true

  let forceAsSystem=false
  if(window.cordova){
    if(opts.forceAsSystem) forceAsSystem=true
    if(opts.forceAsSystemIOS && helper.platform('iOS')) forceAsSystem=true
    if(opts.forceAsSystemAndroid && helper.platform('Android')) forceAsSystem=true
    //console.log('@openHref', "forceAsSystem", forceAsSystem)
  }
  
  //let fileExt = href.split('.').pop()
  let ext = fileExt(href)

  if((_s('conf').inAppBrowerFileTypeExceptions && _s('conf').inAppBrowerFileTypeExceptions.indexOf(ext) > -1) || forceAsSystem) {
    //console.log('@openHref', "Open url in system",ext,_s('conf').inAppBrowerFileTypeExceptions)
    //opens in the system browser
    if(window.cordova) cordova.InAppBrowser.open(href, '_system')
    else window.open(href, '_blank')
  }
  else
  {
    //console.log('@openHref', "Open url in inAppBrowser",ext,cf.inAppBrowerFileTypeExceptions)
    //open in inAppBrowser (not webview, to have the back/done button - FU***ios !!!)
    if(window.cordova) cordova.InAppBrowser.open(href, '_blank', 'enableViewportScale=yes,location=no,allowInlineMediaPlayback=yes,footer=yes')//,usewkwebview=yes')
    else if(opts.normal) window.open(href, '_blank')
    else window.open(href, '_blank', 'location=no')
  }
  return false
}


// --------------------------------------------
// ----- cookies
// --------------------------------------------
export function setCookie(name, value, days, path="/") {
  let expires=""
  if(days) {
    let date = new Date()
    date.setTime(date.getTime()+(days*24*60*60*1000))
    expires= ` expires=${date.toGMTString()};`
  }
  document.cookie = `${name}=${value};${expires} path=${path}`
}

export function getCookie(name) {
  let cookie = {}
  document.cookie.split(';').forEach(function(el) {
    let [key,value] = el.split('=')
    cookie[key.trim()] = value
  })
  return cookie[name]
}


// --------------------------------------------
// ----- platform browser, sound, vibration, colors
// --------------------------------------------
export function vibration(pattern) {
  if('vibrate' in navigator) {
    if(window.cordova && device.platform=='iOS') navigator.vibrate(1)
    else navigator.vibrate(pattern);
  }
}

export function platform(is) {
  let platform=''
  if (typeof window === 'undefined') return
  if(window.cordova) platform=device.platform
  else {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (userAgent.match(/Mac/i)) platform= 'macOS'
    if (userAgent.match(/iPad|iPhone|iPod/i)) platform= 'iOS'
    if (userAgent.match(/android/i)) platform= 'android'
    if (userAgent.match(/windows/i)) platform= 'windows'
    if (!platform) platform=="other"
  }
  return is?(is==platform?true:false):platform
}

export function browser(is){
  let browser=''
  if (typeof window === 'undefined') return
  let userAgent = (navigator.userAgent || navigator.vendor || window.opera).toLowerCase()
  switch (true) {
    case userAgent.indexOf("edge") > -1: browser="edge";break;
    case userAgent.indexOf("edg") > -1: browser="chromium edge";break;
    case userAgent.indexOf("opr") > -1: browser="opera";break;
    case userAgent.indexOf("chrome") > -1: browser="chrome";break;
    case userAgent.indexOf("crios") > -1: browser="chrome";break;
    case userAgent.indexOf("trident") > -1: browser="ie";break;
    case userAgent.indexOf("firefox") > -1: browser="firefox";break;
    case userAgent.indexOf("fxios") > -1: browser="firefox";break;
    case userAgent.indexOf("safari") > -1: browser="safari";break;
    default: browser="other";break;
  }
  return is?(is==browser?true:false):browser
}

export function mobile(is){
  let mobile=false
  if (typeof window === 'undefined') return
  mobile = (navigator.userAgent || navigator.vendor || window.opera).toLowerCase().indexOf("mobile") > -1
  return is?(is===mobile?true:false):mobile
}

export function fullscreenEvent(){ //STATE NOT MORE EXISTENT
  document.addEventListener("fullscreenchange", function (event) {
    _s('state',{isFullscreen: document.fullscreenElement})
  })
}

export function requestFullscreen(elt){
  if(!elt) elt = document.documentElement
  if (elt.requestFullscreen) elt.requestFullscreen()
  else if (elt.mozRequestFullScreen) elt.mozRequestFullScreen() /* Firefox */
  else if (elt.webkitRequestFullscreen) elt.webkitRequestFullscreen() /* Chrome, Safari & Opera */
  else if (elt.msRequestFullscreen) elt.msRequestFullscreen() /* IE/Edge */
}

export function soundAuth(){
  let audio = new Audio('/sounds/multimedia_signature_corporate_004.mp3')
  //audio.play()
  audio.play().catch(() => {  })

  document.querySelector("body").onclick=function(){
    requestFullscreen()
    let audio = new Audio('/sounds/multimedia_signature_corporate_004.mp3')
    audio.play()
  }
}
var snd
export function beep() {
  if(!snd) snd= new Audio()
  snd.src="data:audio/wav;base64,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"
  snd.play().catch(() => {  })
}
export function beepWrong() {
  if(!snd) snd= new Audio()
  snd.src='data:audio/wav;base64,UklGRl9vT19XQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YU'+Array(1e3).join(123)
  snd.play().catch(() => {  })
}

export function silentSound() {
  if(!snd) snd= new Audio()
  snd.src = "data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";
  snd.play().catch(() => {  })
}


export function sound(actions={}){
  if (typeof window === 'undefined') return
  function play(ad){
    const playPromise = ad.play()
    // In browsers that don’t yet support this functionality,
    // playPromise won’t be defined.
    if (playPromise !== undefined) {
      playPromise.then(function() {
        // Automatic playback started!
      }).catch(function(error) {
        //console.log(error)
        //toast("Please touch the screen to permits playing sound")
        // Automatic playback failed.
        // Show a UI element to let the user manually start playback.
      })
    }
  }

  if(!window.audios) window.audios={}
  if(actions.channels=='all') actions.channels=Object.getOwnPropertyNames(window.audios)  
  if(!isObject(actions)) actions={sound: actions, event: "play"}
  actions.channels=asArray(actions.channels)
  if(!actions.channels.length) actions.channels=['default']
  actions.channels.forEach(function(channel) {
    if(!window.audios[channel]) window.audios[channel]=new Audio(actions.sound)
    let ad=window.audios[channel]
    if(actions.src) ad.src=cdn(actions.src)
    ad.loop=actions.loop
    if(actions.volume) ad.volume=actions.volume+0
    if(actions.max) ad.volume=1
    //console.log("@sound", actions, channel)
    if(actions.event) {
      switch (actions.event) {
        case 'up':ad.volume=ad.volume+0.1;break;
        case 'down':ad.volume=ad.volume-0.1;break;
        case 'mute':ad.muted=!ad.muted;break;
        case 'play':play(ad);break;
        case 'toggle':ad.paused?play(ad):ad.pause();break;
        case 'pause':ad.pause();break;
        case 'stop':ad.currentTime = 0;ad.pause(); break;
        case 'restart':
          ad.currentTime = 0
          ad.play()
          break;
      }
    } else play(ad)
  })
}

export function striptags(txt){
  return txt.replace(/(<([^>]+)>)/ig,"")
}

export function clipBoard(txt, withAlert){
  navigator.clipboard.writeText(txt)
  if(withAlert) alert("Copied in clipboard !")
}

export function hexToRgb(hex) {
  if(!hex) return
  let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  hex = hex.replace(shorthandRegex, function(m, r, g, b) {
    return r + r + g + g + b + b;
  })

  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

export function luminance(color) {
  let rgb=hexToRgb(color)
  if(!rgb) return 0
  let a = [rgb.r, rgb.g, rgb.b].map(function (v) {
      v /= 255;
      return v <= 0.03928
          ? v / 12.92
          : Math.pow( (v + 0.055) / 1.055, 2.4 )
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722
}

export function colorRatio(color1, color2) {
  if(!color1 || !color2) return 0
  //from https://dev.to/alvaromontoro/building-your-own-color-contrast-checker-4j7o
  let color1luminance=luminance(color1)
  let color2luminance=luminance(color2)
  const ratio = color1luminance > color2luminance 
    ? ((color2luminance + 0.05) / (color1luminance + 0.05))
    : ((color1luminance + 0.05) / (color2luminance + 0.05))
  return ratio
}

export function randomName() {
  let articles=["the","this", "one", "my","our","their"]
  let adjectives=["amazing", "awesome", "excellent", "fabulous", "fantastic", "great", "incredible", "ineffable", "perfect", "remarkable", "smart", "spectacular", "splendid", "stellar", "super", "ultimate", "unbelievable",  "adventurous",  "abitious", "amusing", "brave", "bright", "charming", "conscientious", "convivial", "courageous", "creative", "decisive", "determined", "diplomatic", "dynamic",  "energetic", "enthusiastic", "exuberant", "fearless", "forceful", "friendly", "funny", "generous", "gentle", "good", "gregarious", "helpful", "honest", "humorous", "imaginative", "impartial", "independent", "intellectual", "intelligent", "intuitive", "inventive", "loyal", "modest", "nice", "passionate", "patient", "persistent ", "pioneering", "philosophical", "placid", "powerful",  "quiet", "rational", "romantic", "sincere", "sociable", "sympathetic",  "tidy",  "versatile"]
  let names=["sharp","berry","pott","squod","fladdock","barley","norris","tiny","dombey","lambert","morris","present","leeford","strong","major","bobster","cleaver","borum","may","edmund","aunt","jenkins","chicken","tobias","dot","marion","scadder","whimple","biddy","johnson","simon","phib","horatio","bradley","miss","simmonds","young","avenger","drood","priscilla","wegg","tupman","flintwinch","copperfield","alfred","snewkes","kenwigs","bart","single","jobling","smauker","charley","sydney","caroline","gills","bodgers","ann","harry","pawkins","shepherd","beadwood","mortimer","drummle","richard","tungay","tomkins","defarge","weevle","slowboy","britain","rugg","bevan","childers","lady","fielding","clickett","parent","chestle","emily","gregsbury","donny","hannibal","tutor","soldier","sheriff","critic","artiste","agent","estimator","director","ranchers","judge","traveler","sailor","brewer","chemist","undertaker","trainer","merchant","millwright","engineer","acrobat","robber","singer","auditor","cook","mortician","academic","buyer","astronomer","major","hunter","teacher","pilot","writer","prisoner","author","senator","scientist","consultant","craftsman","farmer","magician","worshipper","trustee","capitalist","actuary","appraiser","player","horseman","advisor"]
  return fuc(
    articles[Math.floor(Math.random() * articles.length)] + ' '
    + adjectives[Math.floor(Math.random() * adjectives.length)] + ' '
    + names[Math.floor(Math.random() * names.length)])
}


// --------------------------------------------
// ----- debug
// --------------------------------------------
export function alert()
{
  let args = Array.prototype.slice.call(arguments)
  window.alert(flat(args))
}

function flat(args){
  let str = "", msg
  for (var i = 0; i < args.length; i++) {
      msg = args[i]
      if (typeof (msg) == 'object') msg = JSON.stringify(msg) //array & object are object in JS
      str += msg
      if (i < (args.length - 1)) str += ',  '
  }
  return str 
}

// --------------------------------------------
// ----- WebSocket Service

class wsclient {
	constructor(url, opts = {}) {
    if (typeof window === 'undefined') return //means we are in SSR
		this.version="4.0.0"
		this.ws={}
		this.subscribedChannels=[]
		this.url=url || (_s('conf').wsUrl)
    if(!this.url) return
		this.opts=opts //not used
		this.uuid=false
		this.connectedCount=0
    this.onEvent={}
		this.init()
	}

	send(method, payload={}, channels) {
    let self=this
		if(!method) return
		let message={}
    if(self.uuid) message.uuid=self.uuid
		message.msgId=uuid()
		message.method = method
		message.payload={
			...{
				appId: _s('conf').id || undefined,
				lang: _s('lang'),
				tz: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
			}, ...payload
		}

		if(!channels) channels="default"
		message.channels=asArray(channels)
		this.waitForSocketConnection( function(){
			self.ws.send(JSON.stringify(message))
		})
		//console.log('@ws send', method, payload={}, channels)
		return message.msgId
	}

	sendThen(method, payload={}, channels) {//send a message and wait until ret comes back
		let msgId=this.send(method, payload={}, channels)
		return new Promise((resolve, reject)=>{
			window.addEventListener('ws_answer_'+ msgId, (ev)=>{resolve(ev.detail)},{once:true})
		})
	}

	subscribe(channels){
		if(!channels) return
		this.send('subscribe', {channels: asArray(channels)})
	}

	unsubscribe(channels){
		if(!channels) return
		this.send('unsubscribe', {channels: asArray(channels)})
	}

	waitForSocketConnection(callback){
		let self=this
		setTimeout(function () {
			if (self.ws.readyState === 1) {
				if (callback != null) callback()
			} else {
				self.waitForSocketConnection(callback)
			}
		},5)
	}


	init(nextRetryWait=0) {
    //console.log('@ws init', this.version)
		if(nextRetryWait>100) nextRetryWait=0
		this.ws = new WebSocket(this.url)

		this.ws.onerror = (event) => { console.log('@ws Init','No server answer') }

		// Connection opened
		this.ws.onopen = (event) => {
			//re-subscribe if ws was closed (means connectedCount>1)
			if(this.connectedCount) this.subscribe(this.subscribedChannels)
			else this.subscribe(['default', "conf_" + _s('conf').id, "uuid_" + _s('uuid')])

      if(this.onConnect) this.onConnect()

			this.connectedCount++
			//console.log('@ws init','open')
			_s('wscOnline', true)
		}

		// Listen for messages
		this.ws.onmessage = (event) => {
			try	{
				let self=this
				let rcv=JSON.parse(event.data)
				rcv.payload=rcv.payload || {}
				if(!rcv.payload.error) nextRetryWait=0
				//console.log('@ws onmessage','Message from server ', rcv, Date.now())

				this.uuid=rcv.uuid
				//each message received from server reset the list of subscribed channels
				if(	rcv.subscribedChannels ) self.subscribedChannels=rcv.subscribedChannels

				switch (rcv.method) {
					case 'reloadApp':
						document.location.reload(true)
					break
					case 'conf':
						if(rcv.payload.conf) _s('conf', rcv.payload)
					break
					case 'beep':beep();break
					case 'sound':sound(rcv.payload);break
					case 'vibration':vibration(rcv.payload.pattern || [50, 100, 150]);break

					default:
	          if(rcv.method && typeof self.onEvent[rcv.method] === "function") self.onEvent[rcv.method](rcv.payload)
					break
				}

				if(rcv.msgId) {
					window.dispatchEvent(new CustomEvent('ws_answer_'+ rcv.msgId, {detail: rcv.result}))
				}

			} catch(err){console.log('@ws onmessage', 'error', err)}
		}
		this.ws.onclose = (event) => {
			//console.log('@ws onclose','Bye Server!, next retry in', nextRetryWait)
			_s('wscOnline',false )
			let self=this
			setTimeout(function(){ self.init(nextRetryWait+10);}, nextRetryWait)
		}
	}
}